module.exports = __webpack_public_path__ + "media/10.7d6689a4.mp3";